import { render } from "./EntryHeader.vue?vue&type=template&id=9c9f05ba&ts=true"
import script from "./EntryHeader.vue?vue&type=script&lang=ts"
export * from "./EntryHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__